namespace advisorop.components.servicer {

    export class ServicerDmsListController {
        // bindings
        advisoryFirmId: number;
        documentTypes: domains.ILOV[] = [];
        selDocumentType: domains.ILOV;
        documents: any[];

        dgDocumentsOptions: DevExpress.ui.dxDataGridOptions;
        dgDocuments: DevExpress.ui.dxDataGrid;

        // Always false for servicer...
        showUploadToCustodianButton: boolean = false;

        showDisabled: boolean = false;
        includeHistory: boolean = false;

        documentDate: Date = new Date();

        static $inject = ["servicerService", "generalService"];
        constructor(
            private servicerService: advisorop.services.ServicerService,
            private generalService: advisorop.services.GeneralService
        ) {
            this.dgDocumentsOptions = {
                export: {
                    enabled: true,
                    fileName: "Documents"
                },
                bindingOptions: {
                    dataSource: "vm.documents"
                },
                scrolling: {
                    mode: "standard",
                    useNative: true
                },
                //height: "350px",
                paging: { pageSize: 5 },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: false,
                columnAutoWidth: true,
                allowColumnReordering: false,
                allowColumnResizing: true,
                noDataText: "No Documents",
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: true },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: true,
                    width: 240,
                    placeholder: "Search..."
                },
                wordWrapEnabled: true,
                columns: [
                    { dataField: "documentTypeDesc", caption: "Document Type", width: 225 },
                    { dataField: "dateCreated", caption: "Date Uploaded", dataType: "date", width: 100 },
                    { dataField: "documentDate", caption: "Document Date", dataType: "date", width: 100 },
                    { dataField: "version", caption: "Ver.", width: 40 },
                    { dataField: "extension", caption: "Ext.", width: 40 },
                    { dataField: 'enableDisableStatus', caption: 'File Status', width: 70 },
                    { dataField: "id", caption: "Actions", cellTemplate: "colActions", alignment: "left" }
                ],
                masterDetail: {
                    enabled: true,
                    template: "versions",
                    autoExpandAll: false
                },
                onInitialized: e => {
                    this.dgDocuments = e.component;
                }
            };

        }

        uploadedDocuments(object: Object) {
            //console.log("upload completed...");
            this.loadDocuments();
            toastr.success("Document(s) has been successfully uploaded");
        }

        disableDocument(docId: number, docVersion: number) {
            if (window.confirm("This action will disable the document within the system. Are you sure about this?")) {
                this.servicerService.disableDocument(docId, docVersion).then(
                    response => { this.loadDocuments(); toastr.success("Document has been successfully disabled"); },
                    err => this.generalService.showError(err)
                );
            }
        };

        enableDocument(docId: number, docVersion: number) {
            this.servicerService.enableDocument(docId, docVersion).then(
                response => { this.loadDocuments(); toastr.success("Document has been successfully enabled"); },
                err => this.generalService.showError(err)
            );
        };

        // loading methods

        loadDocuments(): void {
            //console.log("Loading documents .... Advisory Firm ID:", this.advisoryFirmId);
            if (this.advisoryFirmId > 0) {
                this.servicerService.getAdvisoryFirmDocumentation(this.advisoryFirmId, this.includeHistory, this.showDisabled)
                    .then(response => {
                        this.documents = response.data;
                    }, err => this.generalService.showError(err));
            }

            //console.log("Documents:", this.documents);
        }

        // overrides
        $onChanges(evt): void {
            //console.log("Here we are getting changes.")
            if (!evt.advisoryFirmId.isFirstChange()) {
                this.loadDocuments();
            } else {
                // documents will be loaded in $onInit
                //console.log("FirstTime");
            }
        }

        $onInit(): void {
            //console.log("$onInit()");
            this.loadDocuments();
        }
    }

    class ServicerDmsList implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                advisoryFirmId: "<"
            };
            this.controller = ServicerDmsListController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/servicer-module/components/servicer-dms-list.html";
        }

    }
    angular.module(Constants.APP).component("servicerDmsList", new ServicerDmsList());
}